import ENTITY_TYPE from "enums/ENTITY_TYPE";
import endpoints from "hooks/api/endpoints";
import useApiWrite from "hooks/api/useApiWrite";
import useProject from "hooks/useProject";
import IndividualItemResponse from "types/IndividualItemResponse";
import NoteDto from "types/NoteDto";

export default function useDeleteEntityNote() {
  const { projectId } = useProject();
  const { write, ...rest } = useApiWrite();

  const deleteEntityNote = (
    entityType?: ENTITY_TYPE,
    entityId?: string,
    noteId?: string,
  ): Promise<IndividualItemResponse<NoteDto>> =>
    write<IndividualItemResponse<NoteDto>>({
      url: noteId ? endpoints.deleteEntityNote(projectId, noteId) : "",
      method: "delete",
      mutateOnSuccess:
        entityType && entityId
          ? [endpoints.getEntityNotes(projectId, entityType, entityId)]
          : [],
    }).then(({ data }) => data);

  return { deleteEntityNote, ...rest };
}
